import { AfterViewInit, Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

@Directive({
  selector: '[appNavigate]'
})
export class NavigateDirective implements AfterViewInit {

  @Input() appNavigate: any[] = [''];
  @Input() navigationOptions: NavigationExtras = {};
  routePrefix = '';
  constructor(
    private el: ElementRef,
    private router: Router
  ) { }

  @HostListener('click') onClick() {
    this.router.navigate([this.routePrefix, ...this.appNavigate], this.navigationOptions)
  }

  ngAfterViewInit(): void {
    this.el.nativeElement.style.cursor = 'pointer';
    this.routePrefix = this.router.url.includes('es') ? 'es' : '';

  }

}
